import React from 'react';
import ATabBar from 'antd-mobile/lib/tab-bar';



export default class TabBar extends ATabBar {}